// Structural data for the history timeline: id, chronological sort key
// (negative = BC) and the place it's filed under. Text lives in the
// per-language content files.
export const baseTimeline = [
  { id: 'perperikon-first-activity', sort: -5000, tag: 'perperikon' },
  { id: 'tatul-earliest-settlement', sort: -4000, tag: 'tatul' },
  { id: 'tatul-sanctuary-in-use', sort: -1850, tag: 'tatul' },
  { id: 'perperikon-medokos', sort: -424, tag: 'perperikon' },
  { id: 'tatul-wall', sort: -250, tag: 'tatul' },
  { id: 'tatul-new-buildings', sort: 250, tag: 'tatul' },
  { id: 'tatul-christian-period', sort: 400, tag: 'tatul' },
  { id: 'perperikon-fortress-ends', sort: 1300, tag: 'perperikon' },
  { id: 'ali-bey-house', sort: 1851, tag: 'momchilgrad' },
  { id: 'kardzhali-liberated', sort: 1912.8, tag: 'kardzhali' },
  { id: 'nanovitsa-joins-bulgaria', sort: 1913.4, tag: 'nanovitsa' },
  { id: 'momchilgrad-renamed', sort: 1934, tag: 'momchilgrad' },
  { id: 'kardzhali-reservoir-built', sort: 1957, tag: 'kardzhali' },
  { id: 'momchilgrad-museum-opens', sort: 1969, tag: 'momchilgrad' },
  { id: 'stone-mushrooms-protected', sort: 1974, tag: 'kardzhali' },
  { id: 'kardzhali-province-restored', sort: 1999, tag: 'kardzhali' },
  { id: 'perperikon-excavations-begin', sort: 2000, tag: 'perperikon' },
  { id: 'nanovitsa-census-2021', sort: 2021, tag: 'nanovitsa' },
]
